export const SYNCABLE_META = {
  type: "object",
  properties: {
    createdAt: {
      type: "string",
      format: "date-time",
    },
    createdByUserId: {
      type: "string",
    },
    updatedAt: {
      type: "string",
      format: "date-time",
    },
    updatedByUserId: {
      type: "string",
    },
  },
  required: ["createdAt", "createdByUserId", "updatedAt", "updatedByUserId"],
} as const;

export const EXTERNAL_CODING_REFERENCE = {
  title: "external coding reference",
  description: "reference to an external coding system for a particular field",
  type: ["object", "null"],
  properties: {
    code: {
      type: "string",
    },
    system: {
      type: ["string", "null"],
    },
  },
  required: ["code", "system"],
} as const;
